<slotcom-limited-time-events-layout
  [event]="randomprize()"
  [modalName]="NonPersistedModalName.RandomPrizeModalComponent"
  [infoModal]="NonPersistedModalName.RandomPrizeInfoModalComponent">
  <ng-container left-container>
    <div class="w-100 h-100 d-flex justify-content-center align-items-center position-relative">
      <div
        class="c-randomprize__icon"
        theming
        themingGroup="randomprize"
        themingAsset="logo"
        [themingOverride]="randomprize()?.assets"></div>
    </div>

    <span class="c-randomprize__copy text">{{ 'home.live-ops.randomprize.text' | translate }}</span>
    <div class="w-100 h-100 d-flex justify-content-center align-items-center flex-column">
      @if (!randomprize()?.infiniteTimes && randomprize()?.maxCompletionTimes === 1) {
        <span class="text times">{{ 'home.live-ops.global.times-valid-coins' | translate }}</span>
      }
      @if (!randomprize()?.infiniteTimes && randomprize()?.maxCompletionTimes > 1) {
        <span class="text times">{{
          'home.live-ops.global.times-valid-coins-2' | translate: { times: randomprize().maxCompletionTimes }
        }}</span>
      }
      @if (randomprize().infiniteTimes) {
        <span class="text times">{{ 'home.live-ops.global.times-valid-coins-3' | translate }}</span>
      }

      @if (hasMinPurchase()) {
        <slotcom-box [classes]="['minPurchase', 'minPurchase--randomprize']">
          <span class="text"
            >{{ 'home.live-ops.global.min-purchase' | translate }} {{ randomprizeMinPurchase() | number }}
            {{ randomprizeCurrencySymbol() }}</span
          >
        </slotcom-box>
      }
    </div>
    <div
      class="c-randomprize__timer"
      [ngClass]="hasMinPurchase() ? '' : 'c-randomprize__timer--margin'">
      <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
      <slotcom-animated-timer
        [showInDays]="true"
        [endDate]="randomprize().endDate"
        (expired)="closeModal()"></slotcom-animated-timer>
    </div>
  </ng-container>

  <ng-container right-container>
    <div class="w-100 d-flex justify-content-center flex-column align-items-center">
      <div
        class="c-randomprize__cookie"
        theming
        themingGroup="randomprize"
        themingAsset="view-cookies"
        [themingOverride]="randomprize()?.assets"></div>

      <span class="text title">{{ 'home.live-ops.randomprize.text-2' | translate }}</span>
      <span
        class="text subtitle"
        [ngClass]="lang() === 'fr' ? 'subtitle-fr' : ''"
        >{{ 'home.live-ops.randomprize.text-3' | translate: { maxPrize: maxReward() } }}</span
      >

      <slotcom-button
        class="c-button--pink"
        (safeClick)="openShop()"
        audioType="functionality">
        {{
          randomprize().statusCultureButtonText[lang()]
            ? (randomprize().statusCultureButtonText[lang()] | uppercase)
            : ('home.buttons.buy-and-play' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </ng-container>
</slotcom-limited-time-events-layout>
